import { Switch } from 'react-router'
import { RouteGroupProps } from './route-group.props'

export const RouteGroup = (props: RouteGroupProps) => {
  return <Switch>{props.children}</Switch>
}
